import React, { useState, Fragment, useRef } from "react";
import { connect } from "react-redux";
import { Table, Input, Button, Popconfirm, message, Empty } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";

import Breadcrumb from "../../components/Breadcrumb";
import ExportCSV from "../../components/Common/ExportCSV";
import LoadingComponent from "../../components/Common/LoadingComponent";
import "./styles.css";

import { useGetPMS, useDeletePMS } from "../../hooks/pms.hooks";

const moment = require("moment");

let tableHeight = 500;

const PmsManager = (props) => {
  tableHeight = window.innerWidth > 700 ?? window.innerHeight - 300;

  const {
    isLoading: isLoadingPMSData,
    data: pmsData,
    refetch: reloadGetPMS,
  } = useGetPMS({
    select: (data) => {
      const updatedData = [...data];
      return updatedData.map((e) => {
        return {
          ...e,
          create_by: e?.create_by?.name ?? "",
          create_at: e?.create_at
            ? moment(e.create_at).local().format("YYYY-MM-DD HH:mm:ss")
            : "",
          update_by: e?.update_by?.name ?? "",
          update_at: e?.update_at
            ? moment(e.update_at).local().format("YYYY-MM-DD HH:mm:ss")
            : "",
        };
      });
    },
  });
  const { mutate: deletePMS } = useDeletePMS({
    onSuccess: (e) => {
      message.success("PMS Deleted Successfully");
      reloadGetPMS();
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  const deletePMSFn = (id) => {
    deletePMS(id);
  };

  const [searchText, setSearchText] = useState();
  const [searchedColumn, setSearchedColumn] = useState();
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    const [searchValue] = selectedKeys;
    confirm();
    setSearchText(searchValue);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput.current = node;
          }}
          placeholder="Search"
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{
            width: 90,
            marginRight: 8,
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: (visible) => {
      visible ?? setTimeout(() => searchInput.current.select());
    },
    render: (text) =>
      text && searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "PMS Name",
      dataIndex: "pms_name",
      key: "pms_name",
      fixed: "left",
      width: "200px",
      ...getColumnSearchProps("pms_name"),
      sorter: (a, b) =>
        a.pms_name ? a.pms_name.localeCompare(b.pms_name) : null,
    },
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      width: "250px",
      ...getColumnSearchProps("_id"),
      sorter: (a, b) => (a._id ? a._id.localeCompare(b._id) : null),
    },
    {
      title: "PMS Version",
      dataIndex: "pms_version",
      key: "pms_version",
      width: "200px",
      ...getColumnSearchProps("pms_version"),
      sorter: (a, b) =>
        a.pms_version ? a.pms_version.localeCompare(b.pms_version) : null,
    },

    {
      title: "Created by",
      dataIndex: "create_by",
      key: "create_by",
      width: "200px",
      ...getColumnSearchProps("create_by"),
    },
    {
      title: "Created at",
      dataIndex: "create_at",
      key: "create_at",
      width: "200px",
      ...getColumnSearchProps("create_at"),
    },
    {
      title: "Updated by",
      dataIndex: "update_by",
      key: "update_by",
      width: "200px",
      ...getColumnSearchProps("update_by"),
    },
    {
      title: "Updated at",
      dataIndex: "update_at",
      key: "update_at",
      width: "200px",
      ...getColumnSearchProps("update_at"),
    },
  ];
  if (props?.api?.permission?.sm_pms_delete) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      width: "100px",
      render: (text, record) => (
        <Popconfirm
          title="Sure to delete?"
          onConfirm={() => deletePMSFn(record._id)}
        >
          <Button
            type="default"
            danger
            size="small"
            style={{ paddingLeft: "5px", paddingRight: "5px" }}
          >
            Delete
          </Button>
        </Popconfirm>
      ),
    });
  }

  return (
    <>
      <div className="container_aa">
        <h3>PMS Manager</h3>
        <Breadcrumb
          routes={[
            { path: "/", breadcrumbName: "Dashboard" },
            { path: "pms-manager", breadcrumbName: "PMS Manager" },
          ]}
        />
      </div>
      <div className="container_ab">
        <div className="container_style_1 user_manager">
          <div className="container_style_1_b" style={{ width: "100%" }}>
            <div className="is_table_3">
              <ExportCSV
                csvData={pmsData ?? []}
                fileName="PMS Manager"
                columnNames={columns}
              />
              <Table
                columns={columns}
                dataSource={pmsData}
                rowKey="_id"
                className="sm-custom-column-header sm-custom-table-row-fixed"
                scroll={{ x: 1550 }}
                locale={{
                  emptyText: isLoadingPMSData ? (
                    <div className="spinner-table">
                      <LoadingComponent />
                    </div>
                  ) : (
                    <Empty
                      description="No such PMS name(s) found"
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                    />
                  ),
                }}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "25", "50", "100"],
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

export default connect(mapStateToProps, null)(PmsManager);
